/*
*###############################################################################
*Module Name                   : CustomerCreditNoteController.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          :  Friday, june 10th 2022, 1:16:56 pm          #
*Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
const setOrderSheetSave = async (
  strCode,
  strDate,
  strSetupLoc,
  strCusCode,
  strLocation,
  strRemarks1,
  dbDiscountPer,
  dbNetAmount,
  LogUserType,
  menuCode,
  LogCompanyCode,
  LocationCode,
  Reason,
  strOrderStatus,
  strDeliveryline1,
  strDeliveryline2,
  strDeliveryline3,
  strRefNo,
  ActiveStat,
  strPayRemarks1,
  ORDERSHEETDETAIL,
  PaymentDet
) => {
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strRunNo: strCode,
    dtTxnDate: strDate,
    dtTxnTime: strDate,
    dtValidDate: strDate,
    strSetupLoc: strSetupLoc,
    strCusCode: strCusCode,
    strLocCode: strLocation,
    strRef1: strRemarks1,
    dbDiscountPer: dbDiscountPer,
    dbNetAmount: dbNetAmount,
    intHedProcess: 1,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: Reason,
    strOrderStatus: strOrderStatus,
    strDeliveryLine1: strDeliveryline1,
    strDeliveryLine2: strDeliveryline2,
    strDeliveryLine3: strDeliveryline3,
    strRefNo: strRefNo,
    intPaid: ActiveStat,
    strPayRemark: strPayRemarks1,
    InvoiceDETAIL: ORDERSHEETDETAIL,
    InvPayDETAIL: PaymentDet,

  })


  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}Invoice`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}
const getQuotationSearch = async LocationCode => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}Invoice/Search/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getOrderSheetSearch = async LocationCode => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}SalesConfirmation/PendingSearch/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getOrderSheetDetails = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}SalesConfirmation/searchDet/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getPendingOrderSheetDetails = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}SalesConfirmation/PendingDet/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getQuotationDetails = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}Invoice/searchDet/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const GetSearchTable = async (id, strSearchCtrl) => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}myReport/searchTable/${id}/${strSearchCtrl}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const setInvoiceCancel = async (
  strCode,
  LogUserType,
  menuCode,
  LogCompanyCode,
  LocationCode,
) => {
  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strRunNo: strCode,
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
  })
  console.log(raw)

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}Invoice/Cancel`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}
const getBalanceOrderSheet = async (LocationCode, strOrderSheetNo) => {
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
  }
  await fetch(`${ApiURL}OrderSheet/BalanceOrderSearch/${LocationCode}/${strOrderSheetNo}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getPayTXNSetup = async (type) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}CreditNote/PayTransSetup/${type}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const LoadPAYTXNDetails = async (type, customer, supplier, location) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  let requestOptions = {
    method: "GET",
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    },
    redirect: "follow",
  };
  await fetch(`${ApiURL}CreditNote/select/${type}/${customer}/${supplier}/${location}  `, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}



const savePayTransaction = async (data) => {
  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${authToken}`);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: data, // Make sure data is serialized
    redirect: "follow",
  };

  try {
    const response = await fetch(`${ApiURL}CreditNote`, requestOptions);
    const result = await response.json();
    if (response.status === 200) {

      return { success: true, data: result.data, message: result.message };
    }

    return { success: false, data: "", message: result.message };
  } catch (error) {
    console.error('Error:', error);
    return { success: false, data: "", message: error };
  }
};



const GetPayTransaction = async (type, runno, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")

  var myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")
  myHeaders.append("Authorization", `Bearer ${authToken}`)


  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    body: data,
    redirect: "follow",
  }
  var data = [];
  var response = false;
  await fetch(`${ApiURL}CreditNote/${type}/${runno}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      if (result.success == true) {
        data = result.data[0]
        response = true
      }
    })
    .catch(error => console.log('error', error))
  return { data, response };
}

const getPaymentModeByHedCode = async (code, payType) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = [];
  var requestOptions = {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: 'follow'
  };
  await fetch(`${ApiURL}paymode/single/paytxn/${code}/${payType}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data;
    })
    .catch(error => console.log('error', error));
  return data;
}

const getPaymentModeDetailByDetCode = async (code) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = [];
  var requestOptions = {
    method: 'GET',
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: 'follow'
  };
  await fetch(`${ApiURL}paymode/details/search/${code}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data;
    })
    .catch(error => console.log('error', error));
  return data;
}

const getReturnPaymentAmount = async (documentNo, payType, payMode, supplier) => {
  try {
    const apiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const response = await fetch(`${apiURL}paymode/returnPayment/${documentNo}/${payType}/${payMode}/${supplier}`, {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
    });

    const result = await response.json();

    if (result.success) {
      return { data: result.data, success: true, msg: result.msg };
    }
    return { data: 0, success: false, msg: result.msg };
  } catch (error) {
    console.error('Error:', error.message);
    return { data: 0, success: false, msg: error.message };
  }
};

export const GetHeaderReasonTypesCashBook = async (type) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
    };

    const response = await fetch(`${ApiURL}ReasonType/select/summary/${type}`, requestOptions);
    const result = await response.json();

    if (result.success) {
      return { success: true, data: result.data }
    } else {
      return { success: false, data: [] }
    }
  } catch (error) {
    console.error("Error:", error);
    return { success: false, data: [] }
  }
};

export {
  setOrderSheetSave,
  getOrderSheetSearch,
  getOrderSheetDetails,
  GetSearchTable,
  getQuotationSearch,
  getQuotationDetails,
  setInvoiceCancel,
  getPendingOrderSheetDetails,
  getBalanceOrderSheet,
  getPayTXNSetup,
  LoadPAYTXNDetails,
  savePayTransaction,
  GetPayTransaction,
  getPaymentModeByHedCode,
  getPaymentModeDetailByDetCode,
  getReturnPaymentAmount
}